(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/contact-person.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/contact-person.js');
"use strict";

const {
  useContext,
  Fragment
} = React;
const {
  HEADER
} = svs.ticket_partner.companyDetails.constants.TEXTS.CONTACT_PERSON;
const {
  OrgNrInput,
  CompanyNameInput,
  ContactInput,
  EmailInput,
  PhoneNrInput,
  CellPhoneNrInput
} = svs.ticket_partner.sharedComponents.input;
const {
  CONTACT_PERSON
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  UPDATE_CONTACT_PERSON
} = svs.ticket_partner.companyDetails.constants.actions;
const ContactDetails = _ref => {
  let {
    state
  } = _ref;
  return Object.values(state).map((val, i) => React.createElement("div", {
    key: _.uniqueId(i)
  }, val));
};
const ContactPerson = () => {
  const {
    state,
    dispatch
  } = useContext(svs.ticket_partner.CompanyDetailsContext);
  const {
    contactPerson,
    organizationNumber,
    companyName,
    phone,
    cellPhone,
    eMail
  } = state.companyDetails;
  const handleChange = e => {
    dispatch({
      type: UPDATE_CONTACT_PERSON,
      payload: {
        field: e.target.id,
        value: e.target.value
      }
    });
  };
  return React.createElement(Fragment, null, React.createElement("h2", null, HEADER), state.companyDetails.edit ? React.createElement(Fragment, null, React.createElement(CompanyNameInput, {
    disabled: true,
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(OrgNrInput, {
    disabled: true,
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(ContactInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails,
    stateField: CONTACT_PERSON
  }), React.createElement(EmailInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(CellPhoneNrInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(PhoneNrInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  })) : React.createElement(ContactDetails, {
    state: [companyName, organizationNumber, contactPerson, eMail, phone, cellPhone]
  }));
};
svs.ticket_partner.companyDetails.components.companyDetailsForm.components.ContactPerson = ContactPerson;

 })(window);